import { Form, Formik, FormikHelpers } from 'formik';
import { AutoGrowTextarea } from 'library/forms';
import { ArrowUpIcon, SendIcon } from 'library/icons';
import { FC, useRef } from 'react';
import * as Yup from 'yup';

const TicketReplySchema = Yup.object().shape({
    message: Yup.string().trim().required('Please enter a message'),
});

interface MessageFormProps {
    onMessage: (message: string) => void;
    maxHeight?: number;
    maxHeightClass?: string;
    disabled: boolean;
}

const MessageForm: FC<MessageFormProps> = (props) => {
    const { onMessage, maxHeight = 100, maxHeightClass, disabled } = props;

    const textAreaRef = useRef(null);

    const handleSubmit = async (values: { message: string }, formikHelpers: FormikHelpers<{ message: string }>) => {
        onMessage(values.message.trim());

        textAreaRef.current.resetHeight();

        formikHelpers.resetForm();
    };

    const handleKeyDown = (e: React.KeyboardEvent, submitForm: () => void, values: { message: string }) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();

            if (values.message.trim() && !disabled) {
                submitForm();
            }
        }
    };

    const textareaStyle = {
        maxHeight: maxHeight ? `${maxHeight}px` : undefined,
    };

    return (
        <Formik
            initialValues={{ message: '' }}
            enableReinitialize
            validationSchema={TicketReplySchema}
            onSubmit={handleSubmit}
            validateOnMount
        >
            {({ values, setFieldValue, submitForm }) => (
                <Form>
                    <div className="px-4 py-4 border rounded-[15px] ai-gradient-border">
                        <div className="flex items-center justify-between gap-4">
                            <AutoGrowTextarea
                                ref={textAreaRef}
                                className="font-medium w-full bg-transparent placeholder:text-grayscale-500 outline-none text-sm max-h-14 hide-scrollbar"
                                name="message"
                                style={maxHeight && !maxHeightClass ? textareaStyle : undefined}
                                placeholder="Ask about your project here..."
                                value={values.message}
                                onChange={(e) => setFieldValue('message', e.target.value)}
                                onKeyDown={(e) => handleKeyDown(e, submitForm, values)}
                            />

                            <div>
                                <button
                                    type="submit"
                                    disabled={!values.message || disabled}
                                    className="ai-gradient grid place-items-center w-11 h-10 rounded-[10px] text-white shadow-[0px_1px_3px_rgba(20,86,242,0.04)] disabled:opacity-50"
                                >
                                    {/* <SendIcon /> */}
                                    <ArrowUpIcon />
                                </button>
                            </div>
                        </div>
                    </div>
                </Form>
            )}
        </Formik>
    );
};

export default MessageForm;
